// Module
var code = `<template> <div class="comp-tooltip-dropdown animation-fadein" data-position.bind="position"> <div class="comp-tooltip-wrap"> <inner-html></inner-html> </div> </div> </template>`;
// Exports
module.exports = code;